const Mauve = {
  muave: {
    main: '#932956',
    light: '#DF5891',
    dark: '#462232',
    '10': '#462232',
    '20': '#632640',
    '30': '#7A2A4C',
    '40': '#932956',
    '50': '#A52259',
    '60': '#C2326F',
    '70': '#DF5891',
    '80': '#F289B5',
    '90': '#FAC4DA',
    '95': '#FFE5F0',
    '99': '#FFF5F9',
  },
};

export default Mauve;
